export const SCREENCM0032 = 'CM0032';
